/**
 * Asynchronously loads the component for DataPullRecordsPage
 */

import { lazyLoad } from 'utils/loadable';

export const DataPullRecordsPage = lazyLoad(
  () => import('./index'),
  module => module.DataPullRecordsPage,
);
